import { Controller, useFormContext } from 'react-hook-form';

import { SelectField } from '@nesso/ui/primitives/select-field';

type TimeZoneFormValues = {
    timeZone: string | null;
};

type Props = {
    options: { value: string; label: string }[];
};

export function TimeZoneField({ options }: Props) {
    const {
        control,
        formState: { isSubmitting },
    } = useFormContext<TimeZoneFormValues>();

    return (
        <Controller
            control={control}
            name="timeZone"
            render={({ field, fieldState }) => (
                <SelectField
                    {...field}
                    id={field.name}
                    label="Time zone"
                    placeholder="Select time zone"
                    value={field.value ?? ''}
                    options={options}
                    disabled={isSubmitting}
                    error={fieldState.error?.message ?? fieldState.invalid}
                    fieldClassName="max-w-88.25"
                />
            )}
        />
    );
}
